import * as React from 'react';
import { SVGProps } from 'react';

const IconTopRightSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.19 5.608H4.525v-2h8.077v8.077h-2V7.022L4.526 13.1l-1.414-1.414L9.19 5.608Z" />
  </svg>
);
export default IconTopRightSizeS;
